import { useEffect, useMemo, useState } from "react";
import { useGetWeeklyScheduleQuery, useUpdateWeeklyScheduleMutation } from "../../../../services/schedulers";
import { TDailySchedule} from "../types";
import {  UpdateWeeklyScheduleArgs } from "../../../../services/schedulers/types";
import { useReportMutationState } from "../../../../hooks/useReportMutationState";
import { TDailyScheduleExtensions } from "../typeExtensions/TDailyScheduleExtensions";


function useWeeklySchedule(objectId: string, resourceGroupId: string): {
    weeklySchedule: TDailySchedule[],
    hasChanges: boolean,
    isSaving: boolean,
    isLoading: boolean,
    isSuccess:boolean,
    save: () => void,
    //addMultipleEvents: (timeFrom: Date, timeTo: Date, value: number | boolean | undefined | null, days: boolean[]) => void,
    updateAll: (days: TDailySchedule[]) => void,
    update: (days: TDailySchedule) => void
} {

    const { data, isLoading, isSuccess } = useGetWeeklyScheduleQuery({ resourceGroupId: resourceGroupId, objectId: objectId });
    const [update, upateResult] = useUpdateWeeklyScheduleMutation();
    useReportMutationState(upateResult, () => { setChanged(false);  });

    const [weeklySchedule, setWeeklySchedule] = useState<TDailySchedule[]>([])
    const [changed, setChanged] = useState(false);

    useEffect(() => {
        const entries = TDailyScheduleExtensions.fromDtos(data ?? []);
        setWeeklySchedule(entries ?? []);
    }, [data]);



    const handleUpdateAll = (days: TDailySchedule[]) => {
        setChanged(true);
        setWeeklySchedule(days);
    }

    const handleUpdate = (item: TDailySchedule) => {
        const day = weeklySchedule.find(v => v.weekday === item.weekday);
        if (!day)
            return;

        const dayIndex = weeklySchedule.indexOf(day);
        weeklySchedule[dayIndex] = item
        setChanged(true);
        setWeeklySchedule([...weeklySchedule]);
    }

    const handleApplyChanges = () => {
        const newval = TDailyScheduleExtensions.toDtos(weeklySchedule);
        const cmd: UpdateWeeklyScheduleArgs = {
            resourceGroupId: resourceGroupId,
            objectId: objectId,
            body: newval
        }
        update(cmd);
    }
    return {
        weeklySchedule: weeklySchedule,
        hasChanges: changed,
        updateAll: handleUpdateAll,
        save: handleApplyChanges,
        isSaving: upateResult.isLoading,
        update: handleUpdate,
        isLoading: isLoading,
        isSuccess: isSuccess
    }
}

export default useWeeklySchedule;






